// client/src/utils/api.js
// ---------------------------------
// Axios instance with auth header
// ---------------------------------
import axios from 'axios';

const baseURL =
    process.env.REACT_APP_API_URL ||
    (process.env.NODE_ENV === 'production' ? '/api' : 'http://localhost:5000/api');

const api = axios.create({ baseURL, withCredentials: true });
const refreshClient = axios.create({ baseURL, withCredentials: true });

let refreshPromise = null;

function storeToken(token) {
    if (token) {
        localStorage.setItem('token', token);
    }
}

// Attach JWT from localStorage if present
api.interceptors.request.use(config => {
    const token = localStorage.getItem('token');
    if (token) {
        config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
});

api.interceptors.response.use(
    response => response,
    async error => {
        const original = error.config || {};
        const status = error.response?.status;
        const isAuthEndpoint = typeof original.url === 'string' && original.url.includes('/auth/');
        if (status === 401 && !original._retry && !isAuthEndpoint) {
            original._retry = true;
            if (!refreshPromise) {
                refreshPromise = refreshClient
                    .post('/auth/refresh')
                    .then(({ data }) => {
                        storeToken(data?.token);
                        return data;
                    })
                    .catch(() => null)
                    .finally(() => {
                        refreshPromise = null;
                    });
            }
            const refreshData = await refreshPromise;
            if (refreshData?.token) {
                original.headers = original.headers || {};
                original.headers.Authorization = `Bearer ${refreshData.token}`;
                return api(original);
            }
        }
        return Promise.reject(error);
    },
);

export default api;

export async function loginRequest(payload) {
    const { data } = await api.post('/auth/login', payload);
    return data;
}

// OTP and self-service password reset helpers were removed from active UI.
// The backend keeps those routes as disabled 410 handlers for old clients.

export async function refreshTokenRequest() {
    const { data } = await refreshClient.post('/auth/refresh');
    storeToken(data?.token);
    return data;
}

export async function logoutRequest() {
    const { data } = await api.post('/auth/logout');
    localStorage.removeItem('token');
    return data;
}
